export default __webpack_public_path__ + "static/SR USA - Producto Orgánico (en inglés) - Certificado-caa47215cd46b0d4f9a2fcd5edc494b6.pdf";